import React, { FC, HTMLAttributes } from "react";
import { Page as PageUI } from "@cc/react-components";
import { ButtonProps } from "@cc/react-components/Button";
import cn from "classnames";

interface PageProps extends HTMLAttributes<HTMLDivElement> {}
const Page: FC<PageProps> & {
  Scrollable: typeof PageScrollable;
  Header: typeof PageHeader;
  Title: typeof PageTitle;
  Actions: typeof PageActions;
  Back: typeof PageBack;
  Body: typeof PageBody;
} = (props: PageProps) => <PageUI {...props} />;

const PageScrollable: FC<PageProps> = ({ className, children, ...props }) => (
  <PageUI className={cn("py-0", className)}>{children}</PageUI>
);

const PageHeader: FC<HTMLAttributes<HTMLDivElement>> = props => (
  <PageUI.Header {...props} />
);

const PageTitle: FC<HTMLAttributes<HTMLDivElement>> = props => (
  <PageUI.Title {...props} />
);

const PageActions: FC<HTMLAttributes<HTMLDivElement>> = props => (
  <PageUI.Actions {...props} />
);

const PageBody = React.forwardRef(
  (props: HTMLAttributes<HTMLDivElement>, ref: React.Ref<HTMLDivElement>) => (
    <PageUI.Body {...props} ref={ref} />
  )
);

const PageBack: FC<ButtonProps> = props => <PageUI.Back {...props} />;

Page.Scrollable = PageScrollable;
Page.Header = PageHeader;
Page.Title = PageTitle;
Page.Actions = PageActions;
Page.Back = PageBack;
Page.Body = PageBody;

export default Page;
